import axios from 'axios';
import { ADMIN_SETUP_TOKEN, ARGO_API_URL, KPI_ANALYTICS_BASE_URL } from '../config';

// RLCS-1593 — service mesh / API gateway URL migration.
// Removed the hardcoded fallback `|| 'https://bff.swob.183295432136.eu-west-1.ac.ericsson.se/'`.
// It pinned the admin client to one specific cluster's BFF ingress host, so the
// image was not portable between environments. It is unreachable today because
// ARGO_API_URL is always a non-empty string (either the value substituted by
// .docker/env.sh or the literal 'url_placeholder'), but it would become active
// the moment the base URL is set to '' for same-origin routing through the mesh
// gateway: `'' || '<hardcoded host>'` would silently send admin traffic to a
// different cluster, while axiosInstance.tsx (no fallback) correctly went
// relative. Removing it keeps all three HTTP clients consistent and is a
// prerequisite for the single-entry-point cutover (RLCS-1587).
const BASE_URL = ARGO_API_URL;
// const BASE_URL = 'http://localhost:3000/';

const adminApi = axios.create({
  baseURL: BASE_URL
});

export const kpiAnalyticsApi = axios.create({
  baseURL: KPI_ANALYTICS_BASE_URL
});

adminApi.interceptors.request.use(
  (config) => {
    config.headers['x-admin-token'] = ADMIN_SETUP_TOKEN;
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

adminApi.interceptors.response.use(
  (response) => {
    // Return the response if it's successful
    return response;
  },
  async (error) => {
    // Handle other errors
    return Promise.reject(error);
  }
);

export default adminApi;
